import React, { FC, PropsWithChildren } from 'react';
import { HStack, Icon, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { IconType } from 'react-icons';

interface HeadingSectionProps extends PropsWithChildren<{}> {
  title: string;
  icon?: IconType;
  subtitle?: number | string;
  dense?: boolean;
}

const HeadingSection: FC<HeadingSectionProps> = ({
  title,
  subtitle,
  icon,
  dense = false,
}) => {

  const HeadingIcon: FC = () => (
    <Icon as={icon} color={useColorModeValue('gray.500', 'gray.400')} />
  );

  return (
    <VStack align='start' gap={0} mb={dense ? 0 : 3}>
      <HStack>
        {icon && <HeadingIcon />}
        <Text
          fontSize='xs'
          fontWeight='bold'
          textTransform='uppercase'
          color='gray.500'
          noOfLines={1}
        >
          {title}
        </Text>
      </HStack>
      <Text
        fontSize='xs'
        fontWeight='semibold'
        color={useColorModeValue('gray.900', 'gray.400')}
      >
        {subtitle}
      </Text>
    </VStack>
  );
};

export default HeadingSection;
